import {
  DesktopIcon,
  FlashIcon,
  LighthouseIcon,
  MobileIcon,
  ServerCloudIcon,
  TimeClockIcon,
} from '#assets/ReactSvg.ts';
import type { HostStatus, Platform } from '#dn-types/host.ts';
import { EntityIcon } from './EntityIcon.tsx';
import { StatusDot } from './StatusDot.tsx';

type Props = {
  isLighthouse: boolean;
  isRelay: boolean;
  platform: Platform | null;
  status: HostStatus;
};

export function DeviceIcon({ isLighthouse, isRelay, platform, status }: Props) {
  let Icon = ServerCloudIcon;

  if (platform === 'mobile') {
    Icon = MobileIcon;
  } else if (platform === 'dnclient-desktop') {
    Icon = DesktopIcon;
  }

  if (isLighthouse) {
    Icon = LighthouseIcon;
  }

  if (isRelay) {
    Icon = FlashIcon;
  }

  if (status === 'unenrolled') {
    Icon = TimeClockIcon;
  }

  return <EntityIcon icon={<Icon fontSize={24} />} statusDot={<StatusDot status={status} />} />;
}
